import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import UsPage from "./pages/UsPage";
import CanalizacionesPage from "./pages/CanalizacionesPage";
import MusicPage from "./pages/MusicPage";
import Contact from "./pages/ContactPage";
import ChannelingDetailPage from "./pages/ChannelingDetailPage";
import ScrollToTop from "./components/ScrollToTop";

const Router = ({ childProps }) => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home {...childProps} />} />

        <Route path="/nosotros" element={<UsPage {...childProps} />} />

        <Route path="/trabajadores-de-la-luz" element={<CanalizacionesPage {...childProps} section={"trabajadores-de-la-luz"} title={"Trabajadores de la Luz"} />} />

        <Route path="/esenios-abuela-ana" element={<CanalizacionesPage {...childProps} section={"esenios-abuela-ana"} title={"Abuela Ana"} />} />
        <Route path="/esenios-maria-magdalena" element={<CanalizacionesPage {...childProps} section={"esenios-maria-magdalena"} title={"María Magdalena"} />} />
        <Route path="/esenios-maria-madre" element={<CanalizacionesPage {...childProps} section={"esenios-maria-madre"} title={"María Madre"} />} />
        <Route path="/esenios-jeshua" element={<CanalizacionesPage {...childProps} section={"esenios-jeshua"} title={"Jeshua"} />} />

        <Route path="/angeles-y-arcangeles/zadquiel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/zadquiel"} title={"Arcángel Zadquiel"} />} />
        <Route path="/angeles-y-arcangeles/uriel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/uriel"} title={"Arcángel Uriel"} />} />
        <Route path="/angeles-y-arcangeles/jofiel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/jofiel"} title={"Arcángel Jofiel"} />} />
        <Route path="/angeles-y-arcangeles/chamuel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/chamuel"} title={"Arcángel Chamuel"} />} />
        <Route path="/angeles-y-arcangeles/rafael" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/rafael"} title={"Arcángel Rafael"} />} />
        <Route path="/angeles-y-arcangeles/gabriel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/gabriel"} title={"Arcángel Gabriel"} />} />
        <Route path="/angeles-y-arcangeles/metatron" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/metatron"} title={"Arcángel Metatron"} />} />
        <Route path="/angeles-y-arcangeles/miguel" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/miguel"} title={"Arcángel Miguel"} />} />
        <Route path="/angeles-y-arcangeles/angeles" element={<CanalizacionesPage {...childProps} section={"angeles-y-arcangeles/angeles"} title={"Ángeles"} />} />

        <Route path="/gaia" element={<CanalizacionesPage {...childProps} section={"gaia"} title={"Gaia"} />} />
        
        <Route path="/musica-mom" element={<MusicPage {...childProps} playlistId={"6tMCcn6SC9VOYeDBO8eqwf"} title="MOM" />} />
        <Route path="/musica-mantras" element={<MusicPage {...childProps} playlistId={"14qnv1ZxAzjUYSVDEU6R10"} title="MANTRAS" />} />
        <Route path="/musica-meditation" element={<MusicPage {...childProps} playlistId={"6WYXMM1sLOg3ObpbL6Fl5S"} title="MEDITATIONS" />} />

        <Route path="/contacto" element={<Contact {...childProps} />} />

        <Route path="/canalizacion/:id" element={<ChannelingDetailPage />} />
      </Routes>
    </>
  );
};

export default Router;